/**
 * Opens the header's dropdown / mega menu automatically on mouse hover
 * (desktop, pointer devices with hover support), instead of requiring a click.
 * Click and keyboard behaviour are left untouched, so touch devices and
 * keyboard/screen-reader navigation keep working exactly as before.
 */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var CLOSE_DELAY = 150;

  function setupHoverMenu(headerMenu) {
    if (headerMenu.hasAttribute('data-hover-menu-initialized')) return;
    headerMenu.setAttribute('data-hover-menu-initialized', 'true');

    var details = headerMenu.querySelector(':scope > details');
    if (!details) return;

    var closeTimer = null;

    function openMenu() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (!details.open) {
        details.open = true;
      }
    }

    function scheduleCloseMenu() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (typeof headerMenu.close === 'function') {
          headerMenu.close();
        } else {
          details.open = false;
        }
        closeTimer = null;
      }, CLOSE_DELAY);
    }

    headerMenu.addEventListener('mouseenter', openMenu);
    headerMenu.addEventListener('mouseleave', scheduleCloseMenu);
  }

  function init() {
    document.querySelectorAll('header-menu').forEach(setupHoverMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan if the header re-renders (e.g. Shopify theme editor section reloads).
  document.addEventListener('shopify:section:load', init);
})();
